/**
 * Returns the Vuetify theme color name for a character.
 * The returned string can be used as a Vuetify `color` prop value,
 * or as `rgb(var(--v-theme-<name>))` in inline styles.
 */
export function useCharacterColor() {
    const characterColors = [
        'amun', 'box', 'eryndras', 'kaze', 'lupus',
        'omega', 'sever', 'smoke', 'swarm', 'titus', 'toshi', 'v4',
        'skeld', 'ampere', 'suture', 'parallax',
    ];

    /**
     * Get the theme color name for a character.
     * @param {string|null} name - Character name (case-insensitive)
     * @returns {string|null} Theme color name or null if not found
     */
    function getCharacterColor(name) {
        if (!name) return null;
        const slug = name.toLowerCase();
        return characterColors.includes(slug) ? slug : null;
    }

    /**
     * Get the CSS rgb() value for a character color using the Vuetify theme variable.
     * @param {string|null} name - Character name (case-insensitive)
     * @returns {string|null} CSS color string or null if not found
     */
    function getCharacterColorCss(name) {
        const color = getCharacterColor(name);
        return color ? `rgb(var(--v-theme-${color}))` : null;
    }

    return {getCharacterColor, getCharacterColorCss};
}
